const ContentWrapper = () => {
  return {
    template: `
      <div style="margin: 1em;">
        <h3>This is a header</h3>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque dolorum eveniet eum aliquid eos inventore numquam quidem, odio voluptatem incidunt rerum nihil doloribus! Ratione veniam debitis similique provident ipsa odit?</p>
        <story/>
        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Pariatur repellat iure ullam at vitae minima nam iste fugiat corrupti, sint mollitia, ipsa officia provident ex sit. Sunt itaque esse numquam.</p>
      </div>
    `,
  };
};

export default ContentWrapper;
